import React from 'react';
import { Box, Chip } from '@mui/material';
import { ChannelGroup } from '../../../../../../../shared/types';
import { ALL_GROUPS } from '../../../types';
import MobileBottomDrawer from './MobileBottomDrawer';

type MobileGroupDrawerProps = {
    open: boolean;
    onClose: () => void;
    channelGroupsWithChannels: ChannelGroup[];
    selectedGroupId: string;
    onSelectGroupId: (groupId: string) => void;
};

const MobileGroupDrawer: React.FC<MobileGroupDrawerProps> = ({
    open,
    onClose,
    channelGroupsWithChannels,
    selectedGroupId,
    onSelectGroupId,
}) => {
    return (
        <MobileBottomDrawer open={open} onClose={onClose} title="Filter">
            <Box
                sx={{
                    pb: 7,
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    alignContent: 'flex-start',
                }}
            >
                <Chip
                    label="All"
                    color={
                        selectedGroupId === ALL_GROUPS ? 'primary' : 'default'
                    }
                    variant={
                        selectedGroupId === ALL_GROUPS ? 'solid' : 'outlined'
                    }
                    onClick={() => {
                        onSelectGroupId(ALL_GROUPS);
                        onClose();
                    }}
                />
                {channelGroupsWithChannels.map((group) => (
                    <Chip
                        key={group._id}
                        label={group.name}
                        color={
                            selectedGroupId === group._id
                                ? 'primary'
                                : 'default'
                        }
                        variant={
                            selectedGroupId === group._id ? 'solid' : 'outlined'
                        }
                        onClick={() => {
                            onSelectGroupId(group._id);
                            onClose();
                        }}
                    />
                ))}
            </Box>
        </MobileBottomDrawer>
    );
};

export default MobileGroupDrawer;
